import { Directive } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

/*
 * confirmPasswordValidator is a cross-field validator and is therefore a form-based validator
 * use this validator to ensure that passwordConfirm and password match
 * assumes that your form control for password is "password" and confirmPassword is "passwordConfirm"
 * in the template, test if the form has errors and the error is the "doesNotMatch" error
 * returns null if they match; returns "doesNotMatch: true" if they fail to match
 * ---------------------------------------------------------------------------------------------------*/

export const confirmPasswordValidator: ValidatorFn = (form: FormGroup): ValidationErrors | null => {
  const passwordControl = form.get('password');
  const confirmPasswordControl = form.get('passwordConfirm');
  if (confirmPasswordControl.errors && !confirmPasswordControl.errors['doesNotMatch']) {
    return;
  }
  return passwordControl.value && confirmPasswordControl.value && (passwordControl.value !== confirmPasswordControl.value) ? {'doesNotMatch': true} : null;
}

@Directive({
  selector: '[ndmsConfirmPasswordValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ConfirmPasswordValidatorDirective, multi: true}]
})

export class ConfirmPasswordValidatorDirective implements Validator {
  validate(form: AbstractControl): ValidationErrors {
    return confirmPasswordValidator(form)
  }
}
